import { ReactNode } from "react";
import { Outlet, useParams } from "react-router";
import { ErrorScreen } from "@lending/components/ErrorScreen/ErrorScreen";
import { useGetInstitutionQuery } from "@lending/hooks/queries/useGetInstitutionQuery";

interface WebFlowGuardProps {
  children?: ReactNode;
}

function WebFlowGuard({ children }: WebFlowGuardProps) {
  const { institution } = useGetInstitutionQuery();
  const { applicationUuid } = useParams<{ applicationUuid: string }>();

  // Check if web flow is enabled
  const hasWebFlow = institution.lending_flows_enabled.includes("institution_site");
  // Standalone Loan Portal apps can continue on app-scoped web routes (e.g. membership share),
  // even at FIs without the web flow. The server still checks access to the application.
  const isPortalApplication =
    Boolean(applicationUuid) && institution.lending_flows_enabled.includes("loan_portal");

  if (!hasWebFlow && !isPortalApplication) {
    return <ErrorScreen />;
  }

  return children ? <>{children}</> : <Outlet />;
}

export { WebFlowGuard };
